export default "__VITE_ASSET__B4B6N8tY__"